<template>
  <div class="c-goods-wrap mh100">
    <div
      class="c-coupon-item"
      :class="{invalid: couponData.status!=0,'full-discount': couponData.couponType == 2}"
    >
      <div class="c-item__label" v-if="couponData.couponType == 0 ||couponData.couponType==1 ">
        全额
        <br />抵扣券
      </div>
      <div class="c-item__label" v-if="couponData.couponType == 2">
        <div>减{{couponData.discountMoney}}</div>
        <span>满{{couponData.fullMoney}}可用</span>
      </div>
      <div class="c-item__info">
        <div class="c-item__title">{{couponData.name}}</div>
        <!-- <div class="c-item__rule">{{couponData.discountContent}}</div> -->
        <div class="c-item__rule">{{couponData.goodsType == 0?'全部商品可用':'部分商品可用'}}</div>
        <div class="c-item__date">有效期至：{{formatDate(couponData.endTime, 'yyyy.MM.dd')}}</div>
        <div :class="'c-invalid-icon c-invalid-icon'+couponData.status"></div>
      </div>
    </div>
    <div class="c-bar"></div>
    <div class="c-label tl">推荐商品</div>
    <ul class="c-list">
      <li v-for="item in goods.records" :key="item.id" @click="jumpToCourse(item)">
        <div class="c-item" v-if="item.type == constants.goodsType.offlineClass">
          <div class="c-thumb c-default-img">
            <img :src="item.imageV" alt />
            <div class="c-tag">{{constants.goodsNames[item.type]}}</div>
          </div>
          <div class="c-info">
            <div class="c-title thidden" v-html="item.name"></div>
            <div class="c-desc thidden" v-html="item.shareDescription"></div>
            <div
              class="c-time"
            >{{formatCourseDate(item.offLineCourseStartTime, item.offLineCourseEndTime)}}</div>
            <div class="c-address">{{item.shareDescription}} | {{item.offLineCourseVenuesName}}</div>
            <div class="c-price">
              <div class="price color-f50">¥{{item.price}}</div>
              <div
                class="c-other color-bbb"
                v-if="item.toBeRegistered != 0"
              >{{constants.offlineClassStatus[item.offLineStatus]}}</div>
              <div
                class="c-other color-f50"
                v-if="item.toBeRegistered == 0 && item.offLineCourseSurplusNum <= 5"
              >仅剩5席</div>
            </div>
          </div>
        </div>
        <div
          class="c-item hor"
          v-if="item.type == constants.goodsType.course ||item.type == constants.goodsType.column"
        >
          <div class="c-thumb c-default-img">
            <img :src="item.imageA" />
            <div class="c-tag">{{constants.goodsNames[item.type]}}</div>
          </div>
          <div class="c-info">
            <div class="c-title thidden" v-html="item.name"></div>
            <div class="c-desc thidden" v-html="item.shareDescription"></div>
            <div class="c-price">
              <div class="price color-f50">¥{{item.price}}</div>
              <div class="c-other color-bbb">{{item.saleNum}}人学习</div>
            </div>
          </div>
        </div>
        <div class="c-item" v-if="item.type == constants.goodsType.training">
          <div class="c-thumb c-default-img">
            <img
              :src="item.imageV"
              alt
            />
            <div class="c-tag">{{constants.goodsNames[item.type]}}</div>
          </div>
          <div class="c-info">
            <div class="c-title thidden" v-html="item.name"></div>
            <div class="c-desc thidden" v-html="item.shareDescription"></div>
            <div class="c-time">{{item.teacherName}}·{{item.teacherTitle}}</div>
            <div class="c-address">&nbsp;</div>
            <div class="c-price">
              <div class="price color-f50">¥{{item.price}}</div>
              <div class="c-other color-bbb">{{item.trainCampStatExp}}</div>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <gxxt-no-data v-if="!isLoadingMore && goods.records.length==0" text="暂无推荐商品～"></gxxt-no-data>
  </div>
</template>

<script>
import { GxxtNoData } from '@/components'
import dates from '@/utils/dates'
import {
  getAppScrollTop,
  getAppScrollHeight,
  getWindowHeight,
} from '@/utils/common'
export default {
  components: {
    GxxtNoData,
  },
  data() {
    return {
      goods: {
        records: [],
        pageNum: 1,
        total: 0,
      },
      isLoadingMore: false,
      more: false,
      couponId: '',
      couponData: {},
    }
  },
  mounted() {
    this.couponId = this.$route.query.couponId
    this.goodsList()
    this.getCouponInfo()
    this.bindScroll()
  },
  unmounted() {
    this.removeScroll()
  },
  methods: {
    formatCourseDate(start, end) {
      return dates.formatCourseTimeCn(start, end)
    },
    jumpToCourse(item) {
      this.$router.push({
        name: 'course-home',
        query: {
          goodsId: item.id,
          adminId: this.$route.query.adminId ? this.$route.query.adminId : '',
          origin: this.$route.query.origin,
          goodsType: item.type,
        },
      })
    },
    async getCouponInfo() {
      let res = await this.api.course.getCouponInfo({ couponId: this.couponId })
      if (res.code == 200) {
        this.couponData = res.data
      }
    },
    async goodsList({ more = false } = {}) {
      if (more && !this.more) return
      this.isLoadingMore = true
      let prev = '',
        ln = this.goods.records.length
      prev =
        this.goods.records[ln - 1] && this.goods.records[ln - 1].sort
          ? this.goods.records[ln - 1].sort
          : ''
      let res = await this.api.course.couponGoods({
        prev: prev,
        id: this.couponId,
      })
      this.isLoadingMore = false
      if (res && res.code == 200) {
        if (more) {
          res.data.records.forEach((item) => {
            this.goods.records.push(item)
          })
        } else {
          this.goods = res.data
        }
        this.more = res.data.more
      }
      console.log(this.goods)
    },
    formatDate(ct, format) {
      return dates.formatDate(ct, format)
    },
    bindScroll() {
      document.getElementById('app').addEventListener('scroll', this.scrollFun)
    },
    removeScroll() {
      this.isLoadingMore = false
      document
        .getElementById('app')
        .removeEventListener('scroll', this.scrollFun)
    },
    scrollFun() {
      let timeAction
      if (this.isLoadingMore) {
        return
      }
      const callback = () => {
        var scrollTop = getAppScrollTop(),
          delta = scrollTop - this.beforeScrollTop
        this.beforeScrollTop = scrollTop
        if (
          delta > 0 &&
          scrollTop + getWindowHeight() + 100 > getAppScrollHeight()
        ) {
          this.loadMoreFn()
        }
      }
      if (timeAction) {
        clearTimeout(timeAction)
      }
      timeAction = setTimeout(callback, 50)
    },
    loadMoreFn() {
      if (this.isLoadingMore) {
        return false
      }
      this.goodsList({ more: true })
    },
  },
}
</script>

<style lang="less" scoped>
.c-goods-wrap {
  background: #f7f7f7;
  padding-top: 26px;
}
.c-coupon-item {
  width: 714px;
  height: 248px;
  background: url('~@/assets/images/my/coupon-item-bg.png') 0 0 no-repeat;
  background-size: 100% 100%;
  margin: 0 auto;
  display: flex;
  margin-bottom: 26px;
  .c-item__label {
    flex: 240px 0 0;
    font-size: 40px;
    font-weight: 600;
    color: #ff5500;
    line-height: 56px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .c-item__info {
    flex: 1 0 0;
    padding: 40px 26px 0;
    text-align: left;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 200px;
  }
  .c-item__title {
    font-size: 30px;
    font-weight: 500;
    color: #222222;
    line-height: 50px;
  }
  .c-item__rule {
    font-size: 24px;
    color: #888888;
    line-height: 44px;
  }
  .c-item__date {
    padding-top: 38px;
    font-size: 24px;
    color: #aaaaaa;
    line-height: 24px;
  }
  .c-can-use {
    position: absolute;
    bottom: 44px;
    right: 34px;
  }
  .c-item.invalid {
    .c-item__label,
    .c-item__title,
    .c-item__rule,
    .c-item__date {
      color: #cccccc;
    }
    .c-can-use {
      display: none;
    }
    .c-invalid-icon {
      display: block;
    }
  }
  .c-invalid-icon,
  .c-invalid-icon1,
  .c-invalid-icon2,
  .c-invalid-icon3 {
    width: 115px;
    height: 115px;
    background: url('~@/assets/images/my/coupon-invalid1.png') 0 0 no-repeat;
    background-size: 100% 100%;
    position: absolute;
    bottom: 18px;
    right: 32px;
    display: none;
  }
  .c-invalid-icon1 {
    background: url('~@/assets/images/my/coupon-invalid1.png') 0 0 no-repeat;
    background-size: 100% 100%;
  }
  .c-invalid-icon2 {
    background: url('~@/assets/images/my/coupon-invalid2.png') 0 0 no-repeat;
    background-size: 100% 100%;
  }
  .c-invalid-icon3 {
    background: url('~@/assets/images/my/coupon-invalid3.png') 0 0 no-repeat;
    background-size: 100% 100%;
  }
  &.full-discount {
    .c-item__label {
      flex-direction: column;
      font-size: 44px;
      span {
        font-size: 28px;
        font-weight: 500;
        line-height: 40px;
      }
    }
  }
}
.c-bar {
  height: 18px;
  background: #efefef;
}
.c-label {
  font-size: 36px;
  font-weight: 500;
  color: #222222;
  line-height: 36px;
  padding: 40px 32px 30px;
}
.c-list {
  padding: 0 32px 40px;
  .c-item {
    padding-bottom: 40px;
    display: flex;
    .c-info {
      flex: 1;
      text-align: left;
      padding-left: 20px;
    }
    .c-title {
      width: 486px;
      height: 48px;
      font-size: 32px;
      font-weight: 500;
      color: #333333;
      line-height: 48px;
    }
    .c-desc {
      width: 486px;
      height: 64px;
      font-size: 26px;
      font-weight: 400;
      color: #666666;
      line-height: 64px;
      margin-bottom: 10px;
    }
    .c-time,
    .c-address {
      font-size: 24px;
      color: #888888;
      line-height: 36px;
    }
    .c-price {
      flex: 48px;
      font-size: 24px;
      text-align: right;
      display: flex;
      justify-content: space-between;
      line-height: 38px;
      .c-other {
        flex: 60% 0 0;
        text-align: right;
        font-size: 24px;
      }
      .price {
        font-weight: 500;
        color: #ff5500;
      }
    }
    .c-thumb {
      width: 180px;
      height: 240px;
      position: relative;
      .c-tag {
        position: absolute;
        width: 76px;
        line-height: 32px;
        background: rgba(0, 0, 0, 0.4);
        border-radius: 4px;
        bottom: 10px;
        right: 10px;
        z-index: 1;
        color: #f9f9f9;
      }
      img {
        width: 100%;
        height: 100%;
        border-radius: 8px;
      }
    }
    &.hor {
      .c-thumb {
        width: 320px;
        height: 178px;
      }
      .c-title {
        width: 340px;
      }
      .c-desc {
        width: 340px;
      }
    }
  }
}
.color-f50 {
  color: #f50;
}
.color-bbb {
  color: #bbb;
}
</style>